import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

export default function CTABand({
  title = "Ready to see your revenue engine clearly?",
  text = "Book a free 30-minute assessment. We will map your biggest revenue bottleneck and give you an honest read on whether we can help.",
  buttonText = "Book a Free Assessment",
  to = "/contact",
  testId = "cta-band-book-button",
}) {
  return (
    <Reveal>
      <section
        data-testid="cta-band"
        className="relative overflow-hidden rounded-[32px] bg-[#1F5FFF] px-6 py-16 text-center sm:px-12 sm:py-20"
      >
        <img
          src="/assets/revgengenius-mark-white.png"
          alt=""
          aria-hidden="true"
          className="pointer-events-none absolute -right-20 -top-24 w-[360px] opacity-[0.12]"
        />
        <h2 className="h2 relative mx-auto max-w-2xl text-white">{title}</h2>
        <p className="relative mx-auto mt-4 max-w-xl text-[1.0625rem] leading-relaxed text-white/85">{text}</p>
        <Link to={to} data-testid={testId} className="btn-white relative mt-9">
          {buttonText} <ArrowRight size={18} />
        </Link>
      </section>
    </Reveal>
  );
}
